import { render, staticRenderFns } from "./ReadMessage.vue?vue&type=template&id=590f72f8&"
import script from "./ReadMessage.vue?vue&type=script&lang=js&"
export * from "./ReadMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports